import { Chart } from 'chart.js';
import { customTooltipCallback } from '../tooltip';
import { ActivityRadarChartSettings } from './types';

export function setupActivityRadarChart(
  chartContext: HTMLCanvasElement,
  settings: ActivityRadarChartSettings
) {
  const data = settings.dataSet.data;

  new Chart(chartContext, {
    type: 'radar',
    data: {
      labels: data.map((x) => x.label),
      datasets: [
        {
          data: data.map((x) => x.value),
          backgroundColor: 'rgba(158, 123, 244, 0.45)',
          borderColor: 'rgb(158, 123, 244)',
          borderWidth: 4,
          pointBackgroundColor: '#6449A8',
          pointBorderColor: '#6449A8',
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: false,
          external: (context) =>
            customTooltipCallback(context, (tooltip) => {
              const dataEntry = data[tooltip.dataIndex];

              return dataEntry.displayValue.toLocaleString();
            }),
        },
      },
      scales: {
        r: {
          min: 0,
          max: settings.maxValue,
          ticks: {
            display: false,
            count: 6,
          },
          grid: {
            color: '#D8D8D8',
          },
          angleLines: {
            color: '#D8D8D8',
          },
          pointLabels: {
            color: '#2d2d2d',
            font: Chart.defaults.font,
          },
        },
      },
    },
  });
}
